/*************************************************************************
 * お知らせ Store Actions
 * @namespace notice
 *************************************************************************/
import { axios } from '@v2/utils/httpRequest.js';

export default {
  /*************************************************************************
   * 全てタブ
   *************************************************************************/
  async getAllList({ getters, commit, dispatch }, params = {}) {
    await dispatch('getTimelines', { page: params.page });
    const timelinesTotalPages = getters.totalPages;
    await dispatch('getNewsList', { page: params.page });
    const newsTotalPages = getters.totalPages;

    commit('updatePagination', {
      pagination: {
        total_pages: timelinesTotalPages >= newsTotalPages ? timelinesTotalPages : newsTotalPages,
        ...getters.pagination,
      },
    });
  },
  clearAllList({ commit }) {
    commit('clearAllList');
    commit('clearTimeline');
    commit('clearNews');
  },
  /*************************************************************************
   * 動物病院からのお知らせタブ
   *************************************************************************/
  async getCurrentPetId() {
    return await axios
      .get('/api/v2/u/pets/current_pet/')
      .then((response) => {
        return response.data.user_pet?.id;
      })
      .catch((error) => {
        console.log(`🚀 fetchCurrentUserPet.error: `, error);
        console.log('通信エラーが発生しました');
      });
  },
  async getTimelines({ commit }, params = {}) {
    await axios
      .get('/api/v2/u/timelines', {
        params: {
          page: params.page,
        },
      })
      .then((response) => {
        console.log('🚀 ~ file: u/notice/actions.js ~ line 41 ~ getTimelines ~ response', response);
        commit('receiveAllTimelines', {
          timelines: response.data.timelines,
          pagination: {
            total_pages: response.data.meta.total_pages,
            current_page: response.data.meta.current_page,
            timelines_count: response.data.meta.timelines_count,
            news_timelines_count: response.data.meta.news_timelines_count,
          },
          hasClinic: response.data.meta.has_clinic,
          isPartner: response.data.meta.is_partner,
        });
      })
      .catch((error) => {
        console.error('🚀 ~ file: u/notice/actions.js ~ line 55 ~ getTimelines ~ error', error);
        console.error('通信エラーが発生しました');
      });
  },
  getTimeline({ commit }, id) {
    axios
      .get(`/api/v2/u/timelines/${String(id)}`)
      .then((response) => {
        console.log(
          '🚀 ~ file: u/notice/actions.jsu/notice/actions.js ~ line 64 ~ getTimeline ~ response.data',
          response.data,
        );
        commit('receiveTimeline', { data: response.data });
      })
      .catch((error) => {
        console.error('🚀 ~ file: u/notice/actions.js ~ line 70 ~ getTimeline ~ error', error);
        console.error('通信エラーが発生しました');
      });
  },
  async readAllTimelines({ commit }) {
    await axios
      .post(`/api/v2/u/timelines/all_read`)
      .then((response) => {
        console.log(
          '🚀 ~ file: u/notice/actions.js ~ line 78 ~ readAllTimelines ~ response.data',
          response.data,
        );
        commit('replaceAllTimelines', {
          timelines: response.data.timelines,
          pagination: {
            total_pages: response.data.meta.total_pages,
            current_page: response.data.meta.current_page,
            timelines_count: response.data.meta.timelines_count,
            news_timelines_count: response.data.meta.news_timelines_count,
          },
        });
      })
      .catch((error) => {
        console.error('🚀 ~ file: u/notice/actions.js ~ line 90 ~ readAllTimelines ~ error', error);
        console.error('通信エラーが発生しました');
      });
  },
  clearTimeline({ commit }) {
    commit('clearTimeline');
  },

  /*************************************************************************
   * ペット手帳からのお知らせタブ
   *************************************************************************/

  async getNewsList({ commit }, params = {}) {
    await axios
      .get('/api/v2/u/news', {
        params: {
          page: params.page,
        },
      })
      .then((response) => {
        console.log('🚀 ~ file: u/notice/actions.js ~ line 110 ~ getNewsList ~ response', response);
        commit('receiveAllNews', {
          news: response.data.news,
          newsTimelines: response.data.news_timelines,
          pagination: {
            total_pages: response.data.meta.total_pages,
            current_page: response.data.meta.current_page,
            news_timelines_count: response.data.meta.news_timelines_count,
            timelines_count: response.data.meta.timelines_count,
          },
        });
      })
      .catch((error) => {
        console.error('🚀 ~ file: u/notice/actions.js ~ line 123 ~ getNewsList ~ error', error);
        console.error('通信エラーが発生しました');
      });
  },
  getNews({ commit }, id) {
    axios
      .get(`/api/v2/u/news/${String(id)}`)
      .then((response) => {
        commit('receiveNews', { data: response.data });
      })
      .catch((error) => {
        console.error('🚀 ~ file: u/notice/actions.js ~ line 134 ~ getNews ~ error', error);
        console.error('通信エラーが発生しました');
      });
  },
  async readAllNews({ commit }) {
    await axios
      .post('/api/v2/u/news/all_read')
      .then((response) => {
        console.log('🚀 ~ file: u/notice/actions.js ~ line 140 ~ readAllNews ~ response', response);
        commit('replaceAllNews', {
          news: response.data.news,
          newsTimelines: response.data.news_timelines,
          pagination: {
            total_pages: response.data.meta.total_pages,
            current_page: response.data.meta.current_page,
            news_timelines_count: response.data.meta.news_timelines_count,
            timelines_count: response.data.meta.timelines_count,
          },
        });
      })
      .catch((error) => {
        console.error('🚀 ~ file: u/notice/actions.js ~ line 155 ~ readAllNews ~ error', error);
        console.error('通信エラーが発生しました');
      });
  },
  clearNews({ commit }) {
    commit('clearNews');
  },

  /*************************************************************************
   * お知らせモーダル用API
   *************************************************************************/
  confirmNotice({ _commit }) {
    axios
      .patch('/api/v2/u/timelines/confirm_notice')
      .then((response) => {
        console.log('🚀 ~ file: u/notice/actions.js ~ confirmNotice ~ response', response);
      })
      .catch((error) => {
        console.error('🚀 ~ file: u/notice/actions.js ~ confirmNotice ~ error', error);
        console.error('通信エラーが発生しました');
      });
  },
};
